// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sub_box":"sub_box-1hsBfUsi","sub_nav":"sub_nav-RmMyJVxS clearfix"};